var sliderthumbs = new Swiper('[data-article-thumbnail]', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  slideToClickedSlide: true,
  freeMode: true,
  watchSlidesProgress: true,
  watchOverflow: true,
});

var slider = new Swiper('[data-article-gallery]', {
  slidesPerView: 1,
  centeredSlides: false,
  spaceBetween: 0,
  watchOverflow: true,

  updateOnWindowResize: true,
  observer: true,
  observeParents: true,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  thumbs: {
    swiper: sliderthumbs,
  },
});
